export const UPLOAD_FILES_MODAL_I18N_PREFIX = "features.topics.components.upload_files_modal";

export const UPLOAD_FILES_MODAL_I18N_KEYS = {
  modal_title:                              "modal_title",
  step_two:                                 "step_two",
  instructions_title:                       "instructions_title",
  file_types_accepted_instructions:         "file_types_accepted_instructions",
  max_file_size_instructions:               "max_file_size_instructions",
  max_data_storage_instructions:            "max_data_storage_instructions",
  more_files_added_later_instructions:      "more_files_added_later_instructions",
  click_here_link_text:                     "click_here_link_text",
  click_for_fomatting_details_instructions: "click_for_fomatting_details_instructions",
  upload_file_button_text:                  "upload_file_button_text",
  cancel_button_text:                       "cancel_button_text",
  done_button_text:                         "done_button_text",
  empty_file_error_message:                 "empty_file_error_message",
  no_content_column_error_message:          "no_content_column_error_message",
  missing_data_in_content_column_error_message:    "missing_data_in_content_column_error_message",
  content_column_exceeds_max_length_error_message: "content_column_exceeds_max_length_error_message",
  missing_data_in_date_column_error_message:       "missing_data_in_date_column_error_message",
  invalid_date_error_message:                      "invalid_date_error_message",
  missing_data_in_source_column_error_message:     "missing_data_in_source_column_error_message",
  source_column_exceeds_max_length_error_message:  "source_column_exceeds_max_length_error_message",
  invalid_source_error_message:                    "invalid_source_error_message",
  exceeded_max_number_of_rows_error_message:       "exceeded_max_number_of_rows_error_message",
  exceeded_max_file_size_error_message:            "exceeded_max_file_size_error_message"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/UploadFilesModali18nConstants.js